document.addEventListener('DOMContentLoaded', function() {
    // Translation initialization
    function getTranslation(key, language) {
        const keyParts = key.split('.');
        let translation = window.customTranslations[language];
        
        for (const part of keyParts) {
            if (translation && translation[part]) {
                translation = translation[part];
            } else {
                return null;
            }
        }
        
        return translation;
    }

    function initializeTranslations() {
        const elements = document.querySelectorAll('[data-custom-translate]');
        const currentLanguage = document.documentElement.lang || 'en';
        
        elements.forEach(element => {
            const translationKey = element.getAttribute('data-custom-translate');
            const translation = getTranslation(translationKey, currentLanguage);
            if (translation) {
                element.textContent = translation;
            }
        });
    }

    // Initialize translations first
    initializeTranslations();

    // Existing upsell widget functionality
    const upsellWidget = document.getElementById('custom-upsell-widget');
    if (!upsellWidget) return; // Exit if widget doesn't exist

    const mainProductId = upsellWidget.dataset.mainProductId;
    const addButtons = document.querySelectorAll('.custom-upsell-add');
    const messageElement = document.getElementById('custom-upsell-message');
    const currentLanguage = document.documentElement.lang || 'en';

    function showMessage(message, isError = false) {
        // Only show error messages, skip success messages
        if (!isError) {
            return; // Exit without showing success messages
        }

        const currentLanguage = document.documentElement.lang || 'en';
        let translatedMessage = message;

        // Only translate error messages
        if (message.includes('Failed to add product')) {
            const translatedError = getTranslation('upsell-widget.Failed to add product', currentLanguage) || 'Failed to add product';
            const translatedTryAgain = getTranslation('upsell-widget.Please try again', currentLanguage) || 'Please try again';
            translatedMessage = `${translatedError}. ${translatedTryAgain}.`;
        } else if (message.includes('Failed to remove product')) {
            const translatedError = getTranslation('upsell-widget.Failed to remove product', currentLanguage) || 'Failed to remove product';
            const translatedTryAgain = getTranslation('upsell-widget.Please try again', currentLanguage) || 'Please try again';
            translatedMessage = `${translatedError}. ${translatedTryAgain}.`;
        }

        messageElement.textContent = translatedMessage;
        messageElement.className = 'error';
        messageElement.style.display = 'block';
        setTimeout(() => {
            messageElement.style.display = 'none';
        }, 3000);
    }

    function addToCart(variantId, quantity) {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: [{
                    id: variantId,
                    quantity: quantity
                }]
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status && data.status !== 200) {
                throw new Error(data.description || 'Error adding product to cart');
            }
            return data;
        });
    }

    function removeFromCart(variantId) {
        return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 0
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status && data.status !== 200) {
                throw new Error(data.description || 'Error removing product from cart');
            }
            return data;
        });
    }

    async function getCartState() {
        const response = await fetch('/cart.js');
        return response.json();
    }

    async function updateCart() {
        try {
            const cartState = await getCartState();
            // Update cart count
            const cartCountElements = document.querySelectorAll('.cart-count');
            cartCountElements.forEach(el => {
                el.textContent = cartState.item_count;
            });

            // If you have a cart subtotal element, update it
            const cartSubtotalElements = document.querySelectorAll('.cart-subtotal');
            cartSubtotalElements.forEach(el => {
                el.innerHTML = Shopify.formatMoney(cartState.total_price);
            });

            // Dispatch a custom event that other parts of your theme might listen for
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartState }));
        } catch (error) {
            console.error('Error updating cart:', error);
        }
    }

    function setAddedState(button, added = false) {
        const variantId = button.dataset.variantId;
        if (added) {
            localStorage.setItem(`upsellAdded_${mainProductId}_${variantId}`, 'true');
            button.classList.add('added');
            button.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="check-icon">
                    <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span data-custom-translate="upsell-widget.Added">Added</span>
            `;
            // Update translation for the newly added element
            const addedText = button.querySelector('[data-custom-translate="upsell-widget.Added"]');
            const translation = getTranslation('upsell-widget.Added', currentLanguage);
            if (translation) addedText.textContent = translation;
        } else {
            localStorage.removeItem(`upsellAdded_${mainProductId}_${variantId}`);
            button.classList.remove('added');
            button.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="cart-icon">
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
                <span data-custom-translate="upsell-widget.Add">Add</span>
            `;
            // Update translation for the newly added element
            const addText = button.querySelector('[data-custom-translate="upsell-widget.Add"]');
            const translation = getTranslation('upsell-widget.Add', currentLanguage);
            if (translation) addText.textContent = translation;
        }
    }

    function loadAddedStates() {
        addButtons.forEach(button => {
            const variantId = button.dataset.variantId;
            if (localStorage.getItem(`upsellAdded_${mainProductId}_${variantId}`) === 'true') {
                setAddedState(button, true);
            } else {
                setAddedState(button, false);
            }
        });
    }

    loadAddedStates();

    addButtons.forEach(button => {
        button.addEventListener('click', function() {
            const item = this.closest('.custom-upsell-item');
            const variantId = this.dataset.variantId;
            const itemName = item.querySelector('.custom-upsell-name').textContent;
            const isAdded = this.classList.contains('added');
            
            this.disabled = true;

            if (isAdded) {
                removeFromCart(variantId)
                    .then(() => {
                        // Removed success message - just update cart and button state
                        updateCart();
                        setAddedState(this, false);
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        showMessage('Failed to remove product. Please try again.', true);
                    })
                    .finally(() => {
                        this.disabled = false;
                    });
            } else {
                addToCart(variantId, 1)
                    .then(() => {
                        // Removed success message - just update cart and button state
                        updateCart();
                        setAddedState(this, true);
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        showMessage('Failed to add product. Please try again.', true);
                    })
                    .finally(() => {
                        this.disabled = false;
                    });
            }
        });
    });
});